import {
  INIT_BOX,
  BOX_FOUND,
  BOX_NOT_FOUND,
  INIT_BOX_CONNECTION_FOUND,
  SELECT_WIFI,
  INIT_BOX_CONNECTION_NOT_FOUND,
  INIT_BOX_CONNECTION,
  WIFI_SCAN_SUCCESS,
  WIFI_SCAN,
  WIFI_SCAN_FAILURE,
  INSERT_SERIAL_NUM,
  INSERT_RP115s_PERMITTED,
} from "../actions/box";

const boxInitialState = {
  boxExistsStatus: null,
  serialNumber: null,
  rp115sPermitted: null,
  connection: {
    initConnectionStatus: null,
    wifi: {
      availableNetworks: [],
      selectedNetwork: {
        essid: null,
        password: null,
        strength: null,
        quality: null,
        channel: null,
        status: null,
      },
      status: null,
    },
    wired: {},
  },
};

const boxReducer = (state = boxInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
    case "LOGOUT_STORE":
      return {
        ...boxInitialState,
      };
    case INIT_BOX:
      return {
        ...state,
        boxExistsStatus: "CHECKING",
      };
    case BOX_FOUND:
      return {
        ...state,
        boxExistsStatus: "FOUND",
        serialNumber: action.payload.serialNumber,
        rp115sPermitted: action.payload.rp115sPermitted,
      };
    case INSERT_SERIAL_NUM:
      return {
        ...state,
        boxExistsStatus: "FOUND",
        serialNumber: action.payload.serialNumber,
      };
    case INSERT_RP115s_PERMITTED:
      return {
        ...state,
        rp115sPermitted: action.payload.rp115sPermitted,
      };
    case BOX_NOT_FOUND:
      return {
        ...state,
        boxExistsStatus: "NOTFOUND",
        serialNumber: null,
        rp115sPermitted: null,
      };
    case INIT_BOX_CONNECTION_FOUND:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: { ...state.connection.wifi },
          initConnectionStatus: "ONLINE",
        },
      };
    case INIT_BOX_CONNECTION:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: { ...state.connection.wifi },
          initConnectionStatus: "SCANNING",
        },
      };
    case WIFI_SCAN:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: { ...state.connection.wifi, status: "SCANNING" },
        },
      };
    case WIFI_SCAN_SUCCESS:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: {
            ...state.connection.wifi,
            availableNetworks: action.payload,
            status: "SUCCESS",
          },
        },
      };
    case WIFI_SCAN_FAILURE:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: {
            ...state.connection.wifi,
            status: "FAILED",
          },
        },
      };
    case INIT_BOX_CONNECTION_NOT_FOUND:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: { ...state.connection.wifi },
          initConnectionStatus: "OFFLINE",
        },
      };
    case SELECT_WIFI:
      return {
        ...state,
        connection: {
          ...state.connection,
          wifi: {
            ...state.connection.wifi,
            selectedNetwork: {
              ...state.connection.wifi.selectedNetwork,
              ...action.payload,
            },
          },
        },
      };
    default:
      return state;
  }
};

export default boxReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/box.js